/* import __COLOCATED_TEMPLATE__ from './account-access.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import ajax from 'embercom/lib/ajax';
import type IntlService from 'embercom/services/intl';
import type IntercomConfirmService from 'embercom/services/intercom-confirm-service';
import { restartableTask } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';

interface Args {}

interface Signature {
  Args: Args;
  Element: never;
}

export default class AccountAccess extends Component<Signature> {
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;
  @service declare intercomConfirmService: IntercomConfirmService;
  @service declare appService: AppService;

  @tracked sessions: $TSFixMe;

  constructor(owner: $TSFixMe, args: Args) {
    super(owner, args);
    this.sessions = this.store.findAll('session-device-detail');
  }

  get app() {
    return this.appService.app;
  }

  get isTerminateSessionRunning() {
    return taskFor(this.terminateSession).isRunning;
  }

  @restartableTask
  *terminateSession(session: $TSFixMe): TaskGenerator<any> {
    let options = {
      title: this.intl.t('new-settings.personal.preferences.sessions.terminate-modal-title'),
      body: this.intl.t('new-settings.personal.preferences.sessions.terminate-modal-confirm-text'),
      confirmButtonText: this.intl.t(
        'new-settings.personal.preferences.sessions.terminate-modal-confirm-button-text',
      ),
    };

    let confirmed = yield this.intercomConfirmService.confirm(options);
    if (!confirmed) {
      return;
    }

    try {
      yield ajax({
        type: 'POST',
        url: '/ember/session_device_details/invalidate_session',
        data: JSON.stringify({
          id: session.get('id'),
          app_id: this.app.id,
        }),
      });

      this.refreshActiveSessions();
      this.notificationsService.notifyConfirmation(
        this.intl.t('new-settings.personal.preferences.sessions.terminated-successfully'),
      );
    } catch (error) {
      this.notificationsService.notifyError(
        this.intl.t('new-settings.personal.preferences.sessions.termination-error'),
      );
    }
  }

  refreshActiveSessions() {
    let activeSessions = this.store.query('session-device-detail', {
      app_id: this.app.id,
    });

    this.sessions = activeSessions;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Personal::AccountSecurity::AccountAccess': typeof AccountAccess;
  }
}
